import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  query BlogFullGeneration($id: ID!) {
    blogFullGeneration(id: $id) {
      taskErrors
      status
    }
  }
`;

interface Result {
  taskErrors: string[] | null;
  status: string;
}

export const queryBlogFullGeneration = async (id: ID) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: { id },
  });

  return getSingleProp<Result>(result.data);
};
